// Build video links and thumbnails from a validated YouTube video ID.
export function getYouTubeVideoId (value) {
  if (typeof value !== 'string' || !value.trim()) return ''

  try {
    const url = new URL(value.trim())
    if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) return ''

    const host = url.hostname.toLowerCase()
    let videoId = ''
    if (host === 'youtu.be') {
      const match = url.pathname.match(/^\/([\w-]+)\/?$/)
      videoId = match ? match[1] : ''
    } else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'www.youtube-nocookie.com', 'youtube-nocookie.com'].includes(host)) {
      if (url.pathname === '/watch') {
        videoId = url.searchParams.get('v') || ''
      } else {
        const match = url.pathname.match(/^\/(?:embed|shorts|live)\/([\w-]+)\/?$/)
        videoId = match ? match[1] : ''
      }
    }

    return /^[\w-]{11}$/.test(videoId) ? videoId : ''
  } catch (error) {
    return ''
  }
}
